// src/api/teamApi.js
import client from "./client";

// Join an existing team via token
export const joinTeam = (data) =>
  client.post("/teams/join-team", data).then((res) => res.data);

// Create a brand new team
export const createTeam = (data) =>
  client.post("/teams/create-team", data).then((res) => res.data);

// Fetch the team the logged-in user belongs to
export const getMyTeam = () =>
  client.get("/teams/my-team").then((res) => res.data);

// NEW: Leave the current team
export const leaveTeam = () =>
  client.post("/teams/leave-team").then((res) => res.data);
